import type { GatewayCondition } from '@lib/api';
import { Chip } from '@ui';
import { conditionView } from '@features/gateways/model/condition';

/** A reader's condition as a badge (Normal · Perlu perhatian · Terputus · Belum pernah terhubung). */
export function GatewayChip({ condition, title }: { condition: GatewayCondition; title?: string }) {
  const v = conditionView(condition);
  return (
    <Chip tone={v.tone} title={title}>
      {v.label}
    </Chip>
  );
}
